import Vue from 'vue'
import { EventBus } from './bus'

const NOTIFY = new Vue()
const setupNotifications = () => {
  EventBus.$on('request-success', payload => NOTIFY.$toastSuccess.fire(payload))
  EventBus.$on('request-error', payload => NOTIFY.$toastError.fire(payload))
}

export { setupNotifications }
